export class UserAppFunctionGroupMap {
    user_id: number;
    app_function_group_id: number;
    id: number;
}
